import {h, Component} from 'preact';
import {connect} from 'preact-redux';

export let playNewMessage;

export default class Audio extends Component
{

    constructor(props)
    {
        super(props);

        this.play = this.play.bind(this);

        playNewMessage = this.playNewMessage.bind(this);

        this.audioElement = null;
    }

    render()
    {
        return (
            <div class='audio-elements'>
                <audio ref={(newMessageAudioElement) => { this.newMessageAudioElement = newMessageAudioElement; }}>
                  <source src={`/common/assets/audio/new-message.mp3`} type='audio/mpeg' />
                </audio>
            </div>
        );
    }

    play()
    {
        var playPromise = this.audioElement.play();

        if (playPromise !== undefined)
        {
            playPromise.then(_ => {})
            .catch(error => {});
        }
    }

    stop()
    {
        if (this.audioElement !== null)
        {
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
        }
    }

    playNewMessage()
    {
        this.stop();
        this.audioElement = this.newMessageAudioElement;
        this.play();
    }
}



// WEBPACK FOOTER //
// ./components/Audio.js